import { render, staticRenderFns } from "./searchBar.vue?vue&type=template&id=5b5f5bea&lang=pug&"
import script from "./searchBar.vue?vue&type=script&lang=js&"
export * from "./searchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports